// Phase 12 — Jarvis sign-in prompt configuration.
// Keep the threshold in one place so A/B tuning doesn't require UI edits.

// Number of USER-sent messages after which the "Save this chat?" soft
// prompt appears inline in the Jarvis conversation. Still non-blocking;
// user can keep chatting and dismiss the prompt.
export const SIGNIN_PROMPT_AFTER_MESSAGES = 5;

export const JARVIS_SIGNIN_DISMISSED_KEY = "jarvis_signin_dismissed";

// Phase 12 — email capture (was a hard modal before). Dismiss persists.
export const JARVIS_EMAIL_CAPTURE_DISMISSED_KEY = "jarvis_email_capture_dismissed";
